import React, { useEffect } from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Button, Textarea } from '../../../../Components/StyledComponents';
import { GoogleMap, useJsApiLoader, Circle, Marker } from '@react-google-maps/api';
import './Area.scss';
import SetDeliveryArea from './SetDeliveryArea/SetDeliveryArea';
import axios from 'axios';
import { alertRef } from '../../../../App';

const Area = () => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyC0PMPir5JCgWEtYAQIrbk0ej72UlQ-1wY"
    })//google map api key
    
    const [ radius, setRadius ] = React.useState(3000)//배달 가능 반경
    const [ isIntroModify, setIsIntroModify] = React.useState(false)//안내문구 수정 여부
    const [ deliveryIntro, setDeliveryIntro ] = React.useState('');//배달지역 안내문구
    const [ center, setCenter ] = React.useState({ lat : 0 , lng : 0})//해당 가맹점의 위도 경도(지도 중심지)
    const [ zoom, setZoom ] = React.useState(11)//지도 zoom level

    useEffect(() => {
        getDeliveryInfo();
    },[])

    //배달 지역 정보 get
    const getDeliveryInfo = () => {
        axios.get('/api/order/info/delivery')
        .then((data) => {
            if(typeof data.data.OrderInfo !== 'undefined'){
                setRadius(data.data.OrderInfo.DeliveryRadius)
                setDeliveryIntro(data.data.OrderInfo.DeliveryAreaIntro)
            }
            setCenter({ lat : data.data.LatLng.coordinates[1], lng : data.data.LatLng.coordinates[0]})
        })
    }

    //반경 조절에 따라 zoom change
    useEffect(() => {
        if(radius <= 1000){
            setZoom(15)
        }else if( radius <= 2000 ){
            setZoom(14)
        }else if( radius <= 4000 ){
            setZoom(13)
        }else {
            setZoom(12)
        }
    },[radius])

    //배달 가능 반경 수정
    const patchAreaRadius = (val) => {
        axios.patch('/api/order/info/delivery_radius', {
            DeliveryRadius : val
        })
        .then((data) => {
            if(data.status === 204){
                getDeliveryInfo()
                modalRef.current.closeModal();
                alertRef.current.showAlert({ title : '배달지역이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //배달지역 안내문구 설정
    const patchDeliveryIntro = () => {
        axios.patch('/api/order/info/delivery_intro',{
            DeliveryAreaIntro : deliveryIntro
        })
        .then((data) => {
            if(data.status === 204){
                getDeliveryInfo()
                setIsIntroModify(false)
                alertRef.current.showAlert({ title : '배달지역 안내문구가 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    const modalRef = React.useRef(null);

    const [map, setMap] = React.useState(null)
    const options = {
        strokeColor: '#f95f53',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#f65f53',
        fillOpacity: 0.35,
        clickable: false,
        draggable: false,
        editable: false,
        visible: true,
        zIndex: 1
    }//지도 polygon option

    //unmount 시 지도 remove
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return (
        <div className='area'>
            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>배달지역설정</p>
                        <p className='info-sub-title'>배달 가능한 지역 반경을 설정해요. (해당 반경내의 고객들에게 매장 노출)</p>
                    </div>
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => modalRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>
                </div>

                <div className='header-divider' ></div>
                <div style={{ width : 860, height : 400 }}>
                    {
                        isLoaded &&
                        <GoogleMap
                            center={center}
                            zoom={zoom}
                            onUnmount={onUnmount}
                            mapContainerStyle={{ width : 860, height : 400 }}
                        >
                            <Circle
                                center={center}
                                radius={radius}
                                options={options}
                            />
                            <Marker
                                position={center}
                            />
                        </GoogleMap>
                    }
                </div>
            </div>

            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>배달지역 안내문구 설정</p>
                        <p className='info-sub-title'>배달 가능한 지역을 입력해요. (주문페이지에서 문구 노출)</p>
                    </div>
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => setIsIntroModify(old => !old)}>
                            { isIntroModify ? '취소하기' : '수정하기'}
                        </Button>
                        {
                            isIntroModify && 
                            <Button variant='main' small style={{ width : 88, marginLeft : 8 }} onClick={() => patchDeliveryIntro()}>
                                저장하기
                            </Button>
                        }
                    </div>
                </div>

                <div className='header-divider' ></div>
                <Textarea
                    disabled={!isIntroModify}
                    value={deliveryIntro}
                    onChange={(e) => setDeliveryIntro(e.target.value)} 
                    style={{ width : '100%', height : 140 }}
                    placeholder='예) 사당1동, 사당4동, 방배1동, 방배4동'
                />
            </div>

            <Modal ref={modalRef} isHeader title='배달 가능 지역 (반경) 수정하기' contentContainer={{ width : 800, display : 'flex' }}>
                <SetDeliveryArea patchAreaRadius={patchAreaRadius} radiusInfo={radius} center={center}/>
            </Modal>
        </div>
    )
}

export default Area;